import { createSlice } from "@reduxjs/toolkit";
import { getLocalStorage } from "../../helpers/session";

export const cartListSlice = createSlice({
	
	name: "cart_list",
	initialState: {
		cart: Array.isArray(getLocalStorage("cartList", true)) ? getLocalStorage("cartList", true) : [],
		errors: [],
	},

	reducers: {
		getCart: (state, action) => {
			// console.log("cart reducer", action.payload)
			// console.log("hello", {state});
			state.cart = [...state.cart, ...action.payload]
		},
		getCartList: (state, action) => {
			state.cart = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getCart, getCartList, getErrors} = cartListSlice.actions

export default cartListSlice.reducer
